export default __webpack_public_path__ + "bbfd18809853d8fb2169c1d516e2e037.png";